import {
  UseMutateFunction,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  CsobSendDataSetResponseDto,
  UserProfileDto,
  UserRole,
} from "@green0meter/api-client";

import { DOMAIN_CSOB } from "../domain";
import { ACTION_GET_CSOB_DATASET_COMPARISON } from "../GetCsobDatasetComparison";

import { csobHubApi } from "@api/services";
import { roleGuard } from "@api";

export const ACTION_SEND_DATASET_TO_CSOB = "SEND_DATASET_TO_CSOB";

const allowedRoles = [UserRole.Owner, UserRole.Manager, UserRole.Respondent];

const sendDataSetToCsob = async (): Promise<CsobSendDataSetResponseDto> => {
  const response = await csobHubApi.csobHubControllerSendDataSetToCsob();

  return response.data;
};

export const useSendDataSetToCsob = (
  user: UserProfileDto | null,
): {
  sendDataSetToCsob: UseMutateFunction<
    CsobSendDataSetResponseDto,
    Error,
    void,
    unknown
  >;
  sendDataSetToCsobEnabled: boolean;
  sendDataSetToCsobError: Error | null;
  isPendingSendDataSetToCsob: boolean;
  isSuccessSendDataSetToCsob: boolean;
} => {
  const enabled = roleGuard(user, allowedRoles);
  const queryClient = useQueryClient();

  const { mutate, isPending, isSuccess, error } = useMutation({
    mutationKey: [DOMAIN_CSOB, ACTION_SEND_DATASET_TO_CSOB],
    mutationFn: enabled ? sendDataSetToCsob : undefined,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [DOMAIN_CSOB, ACTION_GET_CSOB_DATASET_COMPARISON],
      });
    },
  });

  return {
    sendDataSetToCsob: mutate,
    sendDataSetToCsobEnabled: enabled,
    sendDataSetToCsobError: error,
    isPendingSendDataSetToCsob: isPending,
    isSuccessSendDataSetToCsob: isSuccess,
  };
};
